import { z } from 'zod'
import { AsyncFn } from '../../common/functional-core'
import { guidSchema, isoDateStringSchema } from '../../contracts'
import { CompanyGuid, ForCompany } from '../Company/Company'

export type MustacheTemplate = string & {
  readonly __tag: 'MustacheTemplate'
}

export const CUSTOMER_COMMUNICATION_TEMPLATE_NAMES = ['enroute-technician'] as const

export const CustomerCommunicationTemplateNameSchema = z.enum(CUSTOMER_COMMUNICATION_TEMPLATE_NAMES)
export type CustomerCommunicationTemplateName = z.infer<typeof CustomerCommunicationTemplateNameSchema>

export const isCustomerCommunicationTemplateName = (name: string): name is CustomerCommunicationTemplateName => {
  return CustomerCommunicationTemplateNameSchema.safeParse(name).success
}

export const CUSTOMER_COMMUNICATION_TEMPLATE_TYPES = ['email', 'sms'] as const

export const CustomerCommunicationTemplateTypeSchema = z.enum(CUSTOMER_COMMUNICATION_TEMPLATE_TYPES)
export type CustomerCommunicationTemplateType = z.infer<typeof CustomerCommunicationTemplateTypeSchema>

const CustomerCommunicationTemplatesSchema = z.object({
  companyGuid: guidSchema,
  name: CustomerCommunicationTemplateNameSchema,
  type: CustomerCommunicationTemplateTypeSchema,
  mustacheTemplate: z.string(),
  createdAt: isoDateStringSchema,
  updatedAt: isoDateStringSchema,
})

export type CustomerCommunicationTemplate = z.infer<typeof CustomerCommunicationTemplatesSchema>

export type CustomerCommunicationTemplatesReader = AsyncFn<CompanyGuid, CustomerCommunicationTemplate[]>

const EN_ROUTE_TECHNICIAN_CONTEXT_SCHEMA = z.object({
  technicianFirstName: z.string(),
  companyName: z.string(),
  companyPhoneNumber: z.string(),
})

export const CUSTOMER_COMMUNICATION_TEMPLATE_CONTEXT_SCHEMAS = {
  'enroute-technician': EN_ROUTE_TECHNICIAN_CONTEXT_SCHEMA,
} as const

export type CustomerCommunicationTemplateContextSchemaMap = typeof CUSTOMER_COMMUNICATION_TEMPLATE_CONTEXT_SCHEMAS
export type CustomerCommunicationTemplateContext<T extends keyof CustomerCommunicationTemplateContextSchemaMap> =
  z.infer<CustomerCommunicationTemplateContextSchemaMap[T]>

export type FetchCustomerCommunicationTemplateRequest<T extends CustomerCommunicationTemplateName> = {
  name: T
  type: CustomerCommunicationTemplateType
  context: CustomerCommunicationTemplateContext<T>
}

export type CustomerCommunicationTemplateRenderer = AsyncFn<
  ForCompany<FetchCustomerCommunicationTemplateRequest<CustomerCommunicationTemplateName>>,
  string
>
